import { Box, withStyles } from '@material-ui/core';
import { SButton, SText } from '@setvi/shared/components';

export const Container = withStyles({
  root: {
    gap: 24,
    zIndex: 2,
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 24px',
    background: '#FAFAFB',
    borderRadius: 65,
    minWidth: 600,
    width: 'fit-content',
    height: 'fit-content',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)',
    bottom: 20,
    left: 0,
    right: 0,
    margin: 'auto'
  }
})(Box);

export const CancelButton = withStyles(() => ({
  root: {
    textDecoration: 'none',
    fontWeight: 'normal',
    fontSize: 15,
    color: '#6B6B80',
    '&:hover': {
      textDecoration: 'underline',
      background: 'transparent'
    }
  }
}))(SButton);

export const SubmitButton = withStyles(({ palette }) => ({
  root: {
    background: palette.success.main,
    color: '#fff',
    '&:hover': {
      background: palette.success.dark
    }
  }
}))(SButton);

export const ButtonsWrapper = withStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 16
  }
}))(Box);

export const NumberBadge = withStyles(({ palette }) => ({
  root: {
    background: palette.primary.main,
    borderRadius: '50%',
    color: '#fff',
    width: 28,
    height: 28,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 14,
    fontWeight: 600
  }
}))(Box);

export const SelectedWrapper = withStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    fontSize: 15
  }
}))(SText);
